import PropTypes from 'prop-types'

import {NEWS_DETAIL_BASE_CLASS} from '../../config.js'

export const SidebarBanner = props => {
  const {children} = props
  return <div className={`${NEWS_DETAIL_BASE_CLASS}-banner`}>{children}</div>
}

SidebarBanner.propTypes = {
  children: PropTypes.node.isRequired
}
